import { swiperRegister, Swiper } from "@ml/swiper/swiper";

swiperRegister();

// FV フェードスライダー
Swiper({
  el: "swiper-container.js-fv-swiper",
  options: {
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    loop: true,
    speed: 1500,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
    pagination: {
      el: ".p-top__fv-pagination",
      clickable: true,
    },
  },
});

// サンプル用 Swiper
const swiperType1 = Swiper({
    el: "swiper-container.swiper-slide-type-1",
    options: {
        slidesPerView: 1.5,
        spaceBetween: 24,
        centeredSlides: true,
        speed: 500,
        loop: true,
        pagination: {
            clickable: true,
        },
        breakpoints: {
            768: {
                slidesPerView: 2.5,
            },
        },
    },
});

// People Swiper（トップ・社員を知る）
const peopleSwiperEls = Swiper({
    el: "swiper-container.js-people-swiper",
    options: {
        slidesPerView: 1.4,
        spaceBetween: 16,
        centeredSlides: true,
        speed: 500,
        loop: true,
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        },
        breakpoints: {
            390: {
                slidesPerView: 1.5,
                spaceBetween: 16,
            },
            768: {
                slidesPerView: "auto",
                spaceBetween: 20,
            },
            1280: {
                slidesPerView: "auto",
                spaceBetween: 24,
            },
        },
    },
});

peopleSwiperEls.forEach((swiperEl) => {
    const wrapper = swiperEl.closest('.c-people-swiper');
    if (!wrapper) return;
    const prevBtn = wrapper.querySelector('.c-people-swiper__nav-prev');
    const nextBtn = wrapper.querySelector('.c-people-swiper__nav-next');
    const counter = wrapper.querySelector('.c-people-swiper__nav-counter');

    if (prevBtn) prevBtn.addEventListener('click', () => swiperEl.swiper.slidePrev());
    if (nextBtn) nextBtn.addEventListener('click', () => swiperEl.swiper.slideNext());

    if (counter) {
        const total = swiperEl.swiper.slides.length;
        const updateCounter = () => {
            counter.textContent = `${swiperEl.swiper.realIndex + 1} / ${total}`;
        };
        updateCounter();
        swiperEl.swiper.on('slideChange', updateCounter);
    }
});
